"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioButtonGroup = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
const react_1 = __importDefault(require("react"));
const RadioButtonGroup = (props) => (react_1.default.createElement(components_core_1.Layout, { appearance: {
        [components_core_1.Breakpoints.default]: [
            { name: 'a', columns: 7 },
            { name: '.', columns: 1 },
            { name: 'b', columns: 7 },
            { name: '.', columns: 1 },
            { name: 'c', columns: 7 },
            { name: '.', columns: 1 }
        ],
        [components_core_1.Breakpoints.b960]: [
            { name: 'a', columns: 6 },
            { name: '.', columns: 1 },
            { name: 'b', columns: 6 },
            { name: '.', columns: 1 },
            { name: 'c', columns: 6 },
            { name: '.', columns: 4 }
        ]
    } },
    ' ',
    props.fields.map(radioField => (react_1.default.createElement(components_core_1.Container, { wrap: "always", key: radioField.value },
        react_1.default.createElement(components_core_1.RadioButton, { value: radioField.value, label: radioField.label, onClick: () => props.onSelect(props.name, radioField.value), checked: props.selectedValue === radioField.value }))))));
exports.RadioButtonGroup = RadioButtonGroup;
